import { TurnstileServerValidationResponse } from '@marsidev/react-turnstile'
import { envToBool } from './generalHelpers'

export const turnstileVerifyEndpoint = 'https://challenges.cloudflare.com/turnstile/v0/siteverify'

export const isTurnstileEnabled = envToBool(process.env.NEXT_PUBLIC_TURNSTILE_ENABLED)
export const turnstileSiteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || ''
export const turnstileSecretKey = process.env.TURNSTILE_SECRET_KEY || ''

export async function verifyTurnstileToken(token: string): Promise<boolean> {
  const res = await fetch(turnstileVerifyEndpoint, {
    method: 'POST',
    body: `secret=${encodeURIComponent(turnstileSecretKey)}&response=${encodeURIComponent(token)}`,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })

  const data = (await res.json()) as TurnstileServerValidationResponse

  return data.success
}
